const FILTER_CRITERIA = {
  OR: 'or',
  AND: 'and',
};

export default FILTER_CRITERIA;
